module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-revenue-single"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.customers,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'timelog_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("number")(props.row.timelog_hours)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 1550499789)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _vm._e()], 1)]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c77d3ad0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/customers/operations/customerTypeRevenueSingle.vue
// module id = 927
// module chunks = 0